import type { SVGProps } from 'react';

export function EyeOffIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M17.4 17.3993C15.846 18.5839 13.9537 19.2401 12 19.272C5.63636 19.272 2 11.9993 2 11.9993C3.13081 9.89195 4.69921 8.05077 6.6 6.59931M10.0909 4.94477C10.7167 4.79829 11.3573 4.72508 12 4.72659C18.3636 4.72659 22 11.9993 22 11.9993C21.4482 13.0317 20.7901 14.0036 20.0364 14.8993M13.9273 13.9266C13.6776 14.1945 13.3765 14.4095 13.042 14.5585C12.7074 14.7076 12.3463 14.7877 11.9801 14.7942C11.6139 14.8007 11.2501 14.7333 10.9106 14.5961C10.571 14.459 10.2625 14.2548 10.0035 13.9958C9.74452 13.7368 9.54036 13.4284 9.40319 13.0888C9.26602 12.7492 9.19866 12.3854 9.20512 12.0192C9.21158 11.653 9.29174 11.2919 9.4408 10.9574C9.58986 10.6228 9.80478 10.3217 10.0727 10.072"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2L22 22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
